import { ADModalBody, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useEffect, useMemo, useState } from "react";
import { Localization } from "@viamap/viamap2-common";
import jsPDF from "jspdf";
import { ViewButtonIcon } from "src/propertyInfoTemplates/PropertyComponents";
import { MatrikelRapport } from "./MatrikelRapport";
import { MarkRapport } from "./MarkRapport";
import { Feature } from "src/states/ApplicationState";
import { ServitutRapport } from "./ServitutRapport";
import { ManagedWindow } from "src/WindowManager/WindowState";
import { StatTracker } from "src/common/managers/StatTracker";
import { ActionTracker } from "src/common/managers/ActionTracker";
import { MIBIcon } from "src/componentsUtils/MIBIcon";
import { pdfToImage } from "./PDFUtils";
import { Spinner } from "react-bootstrap";
import { Document, Page } from "react-pdf";

export function Datarapport(props: { onGenerate: (pdf: jsPDF) => void, selected, onSelect }) {

   switch (props.selected) {
      case "Matrikeloversigt":
         return <MatrikelRapport onGenerate={props.onGenerate} onSelectRapport={props.onSelect} availableRapports={possibleRapports} currentRapport={props.selected} />;
      case "Markoversigt":
         return <MarkRapport onGenerate={props.onGenerate} onSelectRapport={props.onSelect} availableRapports={possibleRapports} currentRapport={props.selected} />;
      case "Servitutoversigt":
         return <ServitutRapport onGenerate={props.onGenerate} onSelectRapport={props.onSelect} availableRapports={possibleRapports} currentRapport={props.selected} />;
      default:
         return null;
   }

}

const possibleRapports = [
   {
      label: "Matrikeloversigt",
      value: "Matrikeloversigt",
      access: Feature.Matrikeloversigt
   },
   {
      label: "Markoversigt",
      value: "Markoversigt",
      access: Feature.Markoversigt
   },
   {
      label: "Servitutoversigt",
      value: "Servitutoversigt",
      access: Feature.Servitutoversigt
   }
] as { label: string, value: string, access: string }[];


export function DataRapportDialog(props: { managedWindow?: ManagedWindow, onClose: () => void }) {
   const [data, setData] = useState<jsPDF | null>(null);
   const [dataUrl, setDataUrl] = useState<ArrayBuffer | null>(null);

   const [selectedRapport, setSelectedRapport] = useState<string>("Matrikeloversigt");

   useEffect(() => {
      if (data === null) return;
      const abortController = new AbortController();

         if (abortController.signal.aborted) return;
      setDataUrl(data.output("arraybuffer"));
      return () => {
         abortController.abort();
         setDataUrl(null);
      }

   }, [data, selectedRapport])

   if (data !== null) {
      return (
         <AdvancedDragModal
            window={props.managedWindow}
            PosDefault={{ top: "100px", left: "100px", width: "500px", height: "700px" }}
            title={Localization.getText("Preview")} onClose={() => { props.onClose() }}
            subHeaderContent={<>
               <ViewButtonIcon title={Localization.getText("Go back w keyword")} onClick={() => { setData(null); }}><MIBIcon icon="GoBack" /></ViewButtonIcon>
               <ViewButtonIcon title={Localization.getText("Save")} onClick={() => docSave(selectedRapport, data)}><MIBIcon icon="download" /></ViewButtonIcon></>}
         >
            <ADModalBody>
               {dataUrl ?
                  <Document file={dataUrl} className={"DatarapportPDFViewer"} >
                     {Array.from({ length: data.getNumberOfPages() ?? 0 }, (_, i) => i).map((pageIndex) => (
                        <Page pageIndex={pageIndex} key={pageIndex} />
                     ))}
                  </Document>
                  : <Spinner />}
            </ADModalBody>
         </AdvancedDragModal>
      )
   }

   return (
      <AdvancedDragModal
         window={props.managedWindow}
         PosDefault={{ top: "100px", left: "100px", width: "382px" }}
         title={Localization.getText("Data report")} onClose={props.onClose}>
         <Datarapport onGenerate={(pdf: jsPDF) => {
            ActionTracker.track("DataReport", selectedRapport || "Ukendt", "GenerateReport");
            StatTracker.count("DataReport", selectedRapport || "Ukendt");
            setData(pdf)
         }}
            selected={selectedRapport}
            onSelect={setSelectedRapport}
         />
      </AdvancedDragModal>
   )
}

function docDataUrl(name: string, doc?: jsPDF | null) {
   return doc?.output("dataurlstring", { filename: name + ".pdf" }) || "";
}

function docSave(name: string, doc?: jsPDF | null) {
   if (doc) {
      doc.save(name + ".pdf");
   } else {
      console.error("No document to save");
   }
}

function docPrint(doc?: jsPDF | null, update?: (a: jsPDF) => void) {
   if (doc) {
      doc.autoPrint();
      update?.(doc);
   } else {
      console.error("No document to print");
   }
}